// Generated by ts-to-zod
import { z } from 'zod';
import { savedViewSchema } from '../models/savedView.schema';

export const savedViewPatchableFieldsSchema = savedViewSchema.pick({
  name: true,
  query: true,
  shared: true,
  queuesFilter: true,
});

export const patchSavedViewPayloadSchema = savedViewPatchableFieldsSchema.partial();
